
import { Vue, Component, Prop} from "vue-property-decorator";
@Component({
  components: {},
})
export default class PassengerTransportationPermissionCostCenterInput extends Vue {
  text: string = "";

  @Prop() private value!: string;
  @Prop({ default: [] }) private rules!: any[];
  @Prop() private organizationId: string;

  get creatingNew() {
    if (this.value) {
      const match = this.organizationCostCenters.find(cc => cc.toLowerCase() === this.value.toLowerCase());
      if (!match) {
        return true;
      }
    }
    return false;
  }

  get costCenter() {
    return this.value;
  }

  set costCenter(value: string) {
    this.$emit("input", value);
  }

  get canUseAutocomplete() {
    return this.organizationId && this.organizationCostCenters.length > 0;
  }

  get organizationCostCenters(): string[] {
    return this.$store.getters['organization/organizationCostCenterNames'](this.organizationId);
  }

  get costCenters(): string[] {
    let costCenters = JSON.parse(JSON.stringify(this.organizationCostCenters));
    
    if (!this.text) {
      return costCenters;
    }

    const search = this.text.toLowerCase();
    costCenters = costCenters.filter(cc => cc.toLowerCase().startsWith(search));
    const match = costCenters.find(cc => cc.toLocaleLowerCase() === search);
    // if there is no match add typed string to list so user can crete a new costCenter
    if (!match) {
      costCenters.unshift(this.text);
    }

    return costCenters;
  }

}
